import request from '@/utils/request'
//发起提现
export const withdrawal = (data) => {
    return request({
        url: '/client/user/withdrawal',
        method: 'POST',
        data: data
    })
}
//提现记录列表
export const withdrawalList = (data) => {
    return request({
        url: '/client/user/withdrawalList',
        method: 'POST',
        data: data
    })
}

//推广记录列表
export const promotionList = (data) => {
    return request({
        url: '/client/user/promotionList',
        method: 'POST',
        data: data
    })
}
//加入我们
export const joinUs = (data) => {
    return request({
        url: '/client/joinUs/submit',
        method: 'POST',
        data: data
    })
}
//意见反馈
export const feedback = (data) => {
    return request({
        url: '/client/feedback/submit',
        method: 'POST',
        data: data
    })
}

//意见反馈
export const receive = (data) => {
    return request({
        url: '/client/coupon/receive',
        method: 'POST',
        data: data
    })
}
// 获取新人优惠券（无参数）
export const receiveNew = () => {
    return request({
        url: '/client/coupon/receiveNew',
        method: 'POST'
    })
}

// 获取注册优惠券信息
export const getRegisterCoupon = () => {
    return request({
        url: '/client/coupon/getRegisterCoupon',
        method: 'POST'
    })
}

// 获取新人优惠券领取状态
export const getRegisterCouponStatus = () => {
    return request({
        url: '/client/coupon/registerStatus',
        method: 'POST'
    })
}

// 获取可领取优惠券活动列表
export const getCouponCampaignList = () => {
    return request({
        url: '/client/coupon/campaignList',
        method: 'POST'
    })
}

// 领取活动优惠券
export const receiveCouponCampaign = (data) => {
    return request({
        url: '/client/coupon/campaignReceive',
        method: 'POST',
        data: data
    })
}
//用户优惠券列表
export const couponList = (data) => {
    return request({
        url: '/client/coupon/list',
        method: 'POST',
        data: data
    })
}

// 修改密码发送邮件验证码（邮件发送可能需要较长时间，设置60秒超时）
export const modifyPasswordSendMail = () => {
    return request({
        url: '/client/user/modifyPasswordSendMail',
        method: 'POST',
        timeout: 6000
    })
}

// 修改密码
export const modifyPassword = (data) => {
    return request({
        url: '/client/user/modifyPassword',
        method: 'POST',
        data: data
    })
}


// ========== 推广功能升级 V1.0 ==========

/**
 * 获取邀请的用户列表
 */
export const getInvitedUsers = (data) => {
    return request({
        url: '/client/promotion/invitedUsers',
        method: 'POST',
        data: data
    })
}

/**
 * 获取下级用户的订单记录
 * @param {number} userId - 下级用户ID
 */
export const getUserOrders = (userId, data) => {
    return request({
        url: `/client/promotion/userOrders/${userId}`,
        method: 'POST',
        data: data
    })
}

/**
 * 获取佣金明细（含待结算）
 */
export const getCommissionDetail = (data) => {
    return request({
        url: '/client/promotion/commission',
        method: 'POST',
        data: data
    })
}

/**
 * 获取推广数据统计
 */
export const getPromotionStatistics = () => {
    return request({
        url: '/client/promotion/statistics',
        method: 'GET'
    })
}

/**
 * 获取推广商品明细（所有商品及其规格的分佣信息）
 */
export const getPromotionGoodsList = () => {
    return request({
        url: '/client/promotion/goodsList',
        method: 'GET'
    })
}

// ========== 银行卡管理 ==========

/**
 * 获取用户银行卡列表
 */
export const getBankCards = () => {
    return request({
        url: '/client/bankCard/list',
        method: 'GET'
    })
}

/**
 * 添加银行卡
 */
export const addBankCard = (data) => {
    return request({
        url: '/client/bankCard/add',
        method: 'POST',
        data: data
    })
}

/**
 * 更新银行卡
 */
export const updateBankCard = (data) => {
    return request({
        url: '/client/bankCard/update',
        method: 'POST',
        data: data
    })
}

/**
 * 删除银行卡
 */
export const deleteBankCard = (id) => {
    return request({
        url: `/client/bankCard/delete/${id}`,
        method: 'DELETE'
    })
}
